import React, { useState } from 'react';
import { base44 } from '@/api/base44Client';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';
import { Upload } from 'lucide-react';
import { toast } from 'sonner';
import ImageUploadWithMeta from './ImageUploadWithMeta';
import MediaDisplay from '@/components/media/MediaDisplay';
import ResponsiveVersionsPanel from './ResponsiveVersionsPanel';

export default function MediaUploadWithMeta({ type = 'image', url = '', meta = {}, label, fieldId, onTypeChange, onChange, onMetaChange, onUploadingChange, imageMinWidth, imageAspectRatio }) {
  const [uploading, setUploading] = useState(false);
  const uploadVideo = async (event) => {
    const file = event.target.files?.[0];
    if (!file) return;
    setUploading(true);
    onUploadingChange?.(true);
    try {
      const { file_url } = await base44.integrations.Core.UploadFile({ file });
      onChange(file_url);
      toast.success('Video caricato');
    } catch {
      toast.error('Impossibile caricare il video');
    } finally {
      setUploading(false);
      onUploadingChange?.(false);
      event.target.value = '';
    }
  };

  return <div className="space-y-4 rounded-lg border p-4">
    <div className="flex items-center justify-between gap-4"><Label>{label}</Label><select className="h-9 rounded-md border border-input bg-transparent px-3 text-sm" value={type} onChange={(e) => onTypeChange(e.target.value)}><option value="image">Immagine</option><option value="video">Video</option></select></div>
    {type === 'image' ? <>
      <ImageUploadWithMeta value={url} meta={meta} label="Immagine e dati SEO" fieldId={fieldId} minWidth={imageMinWidth} aspectRatio={imageAspectRatio} onUploadingChange={onUploadingChange} onChange={(newUrl) => { onChange(newUrl); if (newUrl !== url && meta.responsive) onMetaChange({ ...meta, responsive: undefined }); }} onMetaChange={(newMeta) => onMetaChange({ ...newMeta, responsive: meta.responsive })} />
      {url && <ResponsiveVersionsPanel imageUrl={url} responsive={meta.responsive} fieldId={fieldId} onChange={(responsive) => onMetaChange({ ...meta, responsive })} />}
    </> : <>
      <div><Label htmlFor={`${fieldId}-url`}>URL YouTube o video</Label><div className="flex gap-2"><Input id={`${fieldId}-url`} value={url} onChange={(e) => onChange(e.target.value)} placeholder="https://youtube.com/watch?v=..." required /><Button type="button" variant="outline" disabled={uploading} onClick={() => document.getElementById(`${fieldId}-upload`).click()}><Upload />{uploading ? 'Caricamento...' : 'Carica'}</Button><input id={`${fieldId}-upload`} type="file" accept="video/*" className="hidden" onChange={uploadVideo} /></div></div>
      {url && <div className="aspect-video overflow-hidden bg-black"><MediaDisplay type="video" url={url} meta={meta} controls className="h-full w-full object-contain" /></div>}
      <div><Label>Titolo SEO *</Label><Input value={meta.title || ''} onChange={(e) => onMetaChange({ ...meta, title: e.target.value })} required /></div>
      <div><Label>Descrizione SEO *</Label><Textarea value={meta.description || ''} onChange={(e) => onMetaChange({ ...meta, description: e.target.value })} required /></div>
      <div><Label>Parole chiave SEO</Label><Input value={meta.tags || ''} onChange={(e) => onMetaChange({ ...meta, tags: e.target.value })} /></div>
    </>}
  </div>;
}